import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Icon, Image, Translate, Button } from '@hydra/common/components';

import { useSyncThirdParty } from '@hydra/common/customHooks';

import connectPlaceholder from '@hydra/assets/img/dashboard/socketPlaceholder.svg';

const useStyles = makeStyles(theme => ({
  placeholderWrapper: {
    height: '300px',
    textAlign: 'center',
    padding: theme.spacing(4.25)
  },
  connectPlaceholder: {
    maxWidth: '100%',
    marginBottom: theme.spacing(2)
  },
  placeholderHeading: {
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightSemibold,
    lineHeight: 'normal',
    margin: theme.spacing(0, 0, 0.5, 0)
  },
  placeholderText: {
    marginBottom: theme.spacing(2.5)
  },
  syncButton: {
    margin: '0 auto'
  }
}));

interface GCSConnectPlaceholderData {
  url: string
  setGsc: any
}

export default function GCSConnectPlaceholder ({ url, setGsc }: GCSConnectPlaceholderData) {
  const classes = useStyles();
  const { handleSyncAccount } = useSyncThirdParty({
    thirdPartyAccount: 'GSCData',
    projectUrl: url,
    updateData: setGsc
  });

  return (
    <div className={classes.placeholderWrapper}>
      <Image className={classes.connectPlaceholder} src={connectPlaceholder} />
      <Translate
        content='gsc_keywords_not_synced_heading'
        component='h2'
        className={classes.placeholderHeading}
      />
      <Translate
        content='gsc_keywords_not_synced_text'
        component='p'
        className={classes.placeholderText}
      />
      <Button
        className={classes.syncButton}
        variant='contained'
        color='primary'
        onClick={handleSyncAccount}
        size='large'
        startIcon={<Icon type='plus' color='white' />}
      >
        <Translate content='gsc_keywords_sync_label' />
      </Button>
    </div>
  );
}
